import React, { Component } from 'react'
import validate from '../images/validate.png'
import AlertMessage from '../widgets/AlertMessage'

class OrgFooter extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			showClose: (props.showClose)? true: false,
			showCancel: (props.showCancel)? true: false,
			showUpdate: (props.showUpdate)? true: false,
			showSubmit: (props.showSubmit)? true: false,
			showExport: (props.showExport)? true: false,
			showDissolve: (props.showDissolve)? true: false
		}
		this.handleSubmit = this.handleSubmit.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
	}

	handleSubmit() {
		this.props.submit()
	}

	eventHandler(e) {
		console.log(e.target.innerHTML)
		if(e.target.value === 'CANCEL') {
			this.setState({
				showConfirmMessage: true,
				aMessage: 'Are you sure you want to cancel?'
			})
		}
		else {
			this.props.eventHandler(e.target)
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.showUpdate != this.props.showUpdate) {
			this.setState({
				showUpdate: (this.props.showUpdate)? true: false,
				showSubmit: (!this.props.showUpdate)? true: false
			})
		}
		if(prevProps.showClose != this.props.showClose) {
			this.setState({showClose: this.props.showClose})
		}
		if(prevProps.showCancel != this.props.showCancel) {
			this.setState({showCancel: this.props.showCancel})
		}
	}

	render() {
		let cStyle
		if(this.props.disabled) {
			cStyle = {"background": "#e2e2e2"}
		}
		return(<div className="org-reg-footer">
			{this.state.showSubmit && <button className="green-two" onClick={this.handleSubmit}
				disabled={this.props.disabled} style={cStyle} value='submit'><img src={validate} id="validate"
				alt="VALIDATE" /> SUBMIT</button>}
			{this.state.showUpdate && <button className="green-two" onClick={this.eventHandler}
				disabled={this.props.disabled} style={cStyle} value='update'>UPDATE</button>}
			{this.state.showClose && <button className="green-two" onClick={this.eventHandler}
				disabled={this.props.disabled} style={cStyle} value='close'>CLOSE</button>}
			{this.state.showCancel && <button className="green-two" onClick={this.eventHandler}
				disabled={this.props.disabled} style={cStyle} value='cancel'>CANCEL</button>}
			{this.state.showExport && <button className="green-two" onClick={this.eventHandler}
				disabled={this.props.disabled} style={cStyle} value='export'>EXPORT</button>}
			{this.state.showDissolve && <button className="dissolve" onClick={this.eventHandler}
				disabled={this.props.disabled} style={cStyle} value='dissolve'>DISSOLVE CLUSTER</button>}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
			onClick={(e) => {
				this.setState({showConfirmMessage: false})
				if(e.target.innerHTML === "NO") {
				}
				else {
					this.props.eventHandler(e.target.innerHTML)
				}
			}} />}
		</div>)
	}
}

export default OrgFooter
